import { ConcreteEncodable } from "./ConcreteEncodable";

import { QuerySortEntryImplEncoder } from "../../encoder/QuerySortEntryImplEncoder";

import * as CubiqTS from "../../index";
import { QuerySortEntry } from "../QuerySortEntry";

export class QuerySortEntryImpl extends ConcreteEncodable implements QuerySortEntry {
  public static enType: string = "com.bcdfx.model.query.QuerySortEntryImpl";

  /*FID=100*/
  public messageId: string;
  /*FID=551*/
  public fieldName: string;
  /*FID=552*/
  public isAscedenting: boolean;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = QuerySortEntryImplEncoder.Instance;
    this.setEncodableType(QuerySortEntryImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "QuerySortEntryImpl[" +
      "messageId=" +
      this.messageId +
      "fieldName=" +
      this.fieldName +
      "isAscedenting=" +
      this.isAscedenting +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
